import * as Types from '../../../generated/gqlTypes';

import { gql } from '@apollo/client';
import { FlatPageFragmentDoc } from '../../fragments/__generated__/FlatPage.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type FlatPageQueryVariables = Types.Exact<{
  url: Types.Scalars['String']['input'];
}>;


export type FlatPageQuery = { flatpage: { id: string, pk: number, title: string, url: string, content: string, registrationRequired: boolean } | null };

export type FlatpagesQueryVariables = Types.Exact<{
  url?: Types.InputMaybe<Types.Scalars['String']['input']>;
}>;


export type FlatpagesQuery = { flatpages: { edges: Array<{ node: { id: string, pk: number, title: string, url: string, content: string, registrationRequired: boolean } }> } };


export const FlatPageDocument = gql`
    query FlatPage($url: String!) {
  flatpage(url: $url) {
    ...FlatPageFragment
  }
}
    ${FlatPageFragmentDoc}`;

/**
 * __useFlatPageQuery__
 *
 * To run a query within a React component, call `useFlatPageQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatPageQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatPageQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFlatPageQuery(baseOptions: Apollo.QueryHookOptions<FlatPageQuery, FlatPageQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatPageQuery, FlatPageQueryVariables>(FlatPageDocument, options);
      }
export function useFlatPageLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatPageQuery, FlatPageQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatPageQuery, FlatPageQueryVariables>(FlatPageDocument, options);
        }
export type FlatPageQueryHookResult = ReturnType<typeof useFlatPageQuery>;
export type FlatPageLazyQueryHookResult = ReturnType<typeof useFlatPageLazyQuery>;
export type FlatPageQueryResult = Apollo.QueryResult<FlatPageQuery, FlatPageQueryVariables>;
export function refetchFlatPageQuery(variables: FlatPageQueryVariables) {
      return { query: FlatPageDocument, variables: variables }
    }
export const FlatpagesDocument = gql`
    query Flatpages($url: String) {
  flatpages(first: 100, filters: {url: {iContains: $url}}) {
    edges {
      node {
        ...FlatPageFragment
      }
    }
  }
}
    ${FlatPageFragmentDoc}`;

/**
 * __useFlatpagesQuery__
 *
 * To run a query within a React component, call `useFlatpagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useFlatpagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useFlatpagesQuery({
 *   variables: {
 *      url: // value for 'url'
 *   },
 * });
 */
export function useFlatpagesQuery(baseOptions?: Apollo.QueryHookOptions<FlatpagesQuery, FlatpagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<FlatpagesQuery, FlatpagesQueryVariables>(FlatpagesDocument, options);
      }
export function useFlatpagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<FlatpagesQuery, FlatpagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<FlatpagesQuery, FlatpagesQueryVariables>(FlatpagesDocument, options);
        }
export type FlatpagesQueryHookResult = ReturnType<typeof useFlatpagesQuery>;
export type FlatpagesLazyQueryHookResult = ReturnType<typeof useFlatpagesLazyQuery>;
export type FlatpagesQueryResult = Apollo.QueryResult<FlatpagesQuery, FlatpagesQueryVariables>;
export function refetchFlatpagesQuery(variables?: FlatpagesQueryVariables) {
      return { query: FlatpagesDocument, variables: variables }
    }